import React from "react";
import "./OlaplexLandingWork.css";
import OlaplexLandingWorkHead from "./OlaplexLandingWorkHead";
import OlaplexLandingWorkMain from "./OlaplexLandingWorkMain";
const OlaplexLandingWork = () => {
  return (
    <div className="olaplexLandingWork">
      <OlaplexLandingWorkHead />
      <OlaplexLandingWorkMain />
    </div>
  );
};

export default OlaplexLandingWork;
